<template>
  <div class="login-parent">
    <section class="content">
      <div class="container">
        <div class="loginbox">
          <div class="login-leftside">
          </div>

          <b-form @submit.prevent="loginClicked">
            <h4> Willkommen bei Spoctitty </h4>
            <p> Heute ist ein guter Tag um fit zu bleiben!</p>
            <div v-show="loginError" class="alert alert-danger">Username oder Passwort falsch</div>
            <div style="height: 240px">
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" id="username" icon="heart" placeholder="Username"
                                  v-model="username" :validation="validation" type="text" autocomplete="username"/>
              </div>
              <div class="logininput">
                <validation-input v-on:focus="resetErrors()" icon="key" id="password" placeholder="Passwort" v-model="password"
                                  :validation="validation" type="password" autocomplete="current-password"/>
              </div>
            </div>
            <div class="modalbuttons">
              <router-link to="/register" class="btn btn-link">Noch kein Konto?</router-link>
              <button class="btn btn-primary">Login</button>
            </div>
          </b-form>
        </div>
      </div>
    </section>
    <b-modal
        id="modal-enter-code"
        ref="modal"
        ok-only
        title="Geben Sie den Registrierungscode ein"
        @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleCodeEntered">
        <div v-show="registrationCodeError" class="alert alert-danger">Registrierungscode falsch. Bitte versuchen Sie es
          erneut
        </div>
        <div v-show="registrationCodeExpiredError" class="alert alert-danger">Registrierungscode abgelaufen. Bitte
          fordern Sie einen neuen an
        </div>
        <validation-input id="codeInput" label="Registrierungscode" v-model="registrationCode"
                          :validation="validationCode"/>
      </form>
    </b-modal>
  </div>
</template>

<script>

import {userService} from "@/services/user.service";
import {router} from "@/core/router";
import ValidationInput from "./shared/ValidationInput";


export default {
  name: 'Login',
  components: {
    ValidationInput
  },
  created() {
    const status = this.$route.params.codeStatus;
    if (status === "success") {
      this.showToast("Sie können sich jetzt einloggen", "Registrierung bestätigt!", "success")
    } else if (status === "codeused") {
      this.showToast("Code wurde schon benutzt", "Registrierung fehlgeschlagen!", "warning")
    } else if (status === "invalid") {
      this.showToast("Registrierungslink ist nicht korrekt", "Bestätigung fehlgeschlagen!", "danger")
    } else if (status === "exception") {
      this.showToast("Es ist ein unerwarteter fehler aufgetreten. Nach dem Login können Sie Ihren Code manuell eintragen", "Registrierung fehlgeschlagen!", "danger")
    }
  },
  data() {
    return {
      validation: {
        submitted: false,
        username: {
          dirty: false,
          required: true
        },
        password: {
          dirty: false,
          required: true,
          requiredMessage: "Bitte Passwort angeben"
        }
      },
      validationCode: {
        submitted: false,
        codeInput: {
          dirty: false,
          required: true,
          minLength: 4,
          maxLength: 4,
          requiredMessage: "Bitte 4-stelligen Code eingeben",
          minLengthMessage: "Bitte 4-stelligen Code eingeben",
          maxLengthMessage: "Bitte 4-stelligen Code eingeben"
        }
      },
      username: "",
      password: "",
      registrationCode: "",
      loginError: false,
      registrationCodeError: false,
      registrationCodeExpiredError: false
    }
  },
  methods: {
    loginClicked() {
      this.validation.submitted = true;
      if (this.username.length === 0 || this.password.length === 0) {
        return;
      }
      const {username, password} = this;
      if (username && password) {
        userService.login(this.username, this.password)
            .then((res) => {
              this.validation.submitted = false;
              if (res.code === 1) {
                router.push({path: '/home'})
              } else if (res.code === 71) {
                localStorage.setItem("token", res.token);
                localStorage.setItem("username", username);
                localStorage.setItem('user-type', res.type ? res.type.id : 1);
                this.showCodeModal()
              } else {
                this.loginError = true
              }
            })
      }
    },
    resetErrors() {
      this.loginError = false;
      this.registrationCodeError = false;
      this.registrationCodeExpiredError = false;
    },
    showCodeModal() {
      this.$bvModal.show('modal-enter-code')
    },
    //if user press button
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleCodeEntered()
    },
    // if user press enter
    handleCodeEntered() {
      this.validationCode.submitted = true;
      if (this.registrationCode.length !== 4) {
        return;
      }
      // Push the name to submitted names
      userService.confirmRegistration(this.registrationCode)
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide('modal-enter-code');
              this.$root.$bvToast.toast(`Sie können jetzt Spoctivity benutzen!`, {
                title: 'E-Mail Adresse erfolgreich bestätigt!',
                autoHideDelay: 5000,
                variant: "success"
              });
              router.push({path: '/home'});
            })

          })
          .catch((res) => {
            // no code required
            if (res.response.code === 11) {
              router.push({path: '/home'});
            } else if (res.response.code === 91) {
              this.registrationCodeExpiredError = true;
            } else {
              this.registrationCodeError = true;
            }
          });
    },
    showToast(message, title, variant) {
      this.$root.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        variant: variant
      });
    }
  }
}
</script>

<style scoped>
.login-parent {
  font-size: 14px;
  color: #2a3237;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 600px;

}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.loginheader {
  margin: 20px auto 0;
  text-align: center;
}

.loginheader a {
  margin-left: 10px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  font-family: HighlandGothicFLF;
  color: black;
}

.loginheader img {
  vertical-align: middle;
}

.loginbox {
  display: flex;
  flex-direction: row;
  width: auto;
  height: auto;
  margin: auto auto;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 96px -10px rgba(0, 0, 0, 0.75);
  overflow: hidden;
}

.loginbox .login-leftside {
  width: 200px;
  height: auto;
  min-height: 100%;
  background-image: url("https://images5.alphacoders.com/671/thumb-1920-671148.jpg");
  background-size: cover;
  transition: all 0.5s;
}

.loginbox form {
  padding: 40px 30px;
  background: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.loginbox form h3 {
  margin-bottom: 20px;
}

.loginbox form p {
  line-height: 155%;
  font-size: 14px;
  color: #000;
  opacity: .65;
  font-weight: 400;
  max-width: 200px;
  margin-bottom: 40px;
}

.loginbox form .logininput {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.loginbox form .logininput > div {
  border: none;
  box-shadow: none;
}

.loginbox form input {
  width: calc(100% - 44px);
  margin-left: auto;
  display: flex;
}

.loginbox form .logininput .loginicon {
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  width: 44px;
  display: flex;
}

.loginbox form .logininput .loginicon i {
  height: 30px;
  width: 30px;
  margin: auto;
  transition: all .3s ease;
}

.loginbox form .modalbuttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.modalbuttons a {
  color: rgba(51, 51, 51, 0.6);
  font-size: 14px;
}

.loginbox form button {
  width: unset;
}

@media screen and (max-width: 768px) {

  .loginbox .login-leftside {
    width: 100px;
  }
}
</style>
